var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "ax-navbar__third-level-menu" },
    [
      _vm._l(_vm.items, function(item) {
        return [
          _c(
            "li",
            { key: item.caption, staticClass: "ax-navbar__sub-level-item-row" },
            [
              _c("div", { staticClass: "ax-navbar__sub-level-item-col" }, [
                _c(
                  "a",
                  {
                    staticClass: "ax-navbar__sub-level-menu-link",
                    class: _vm.additionalClassesForItem(item),
                    attrs: {
                      href: item.actionUrl,
                      target: item.window === "newWindow" ? "_blank" : ""
                    },
                    on: {
                      click: function($event) {
                        return _vm.navigateAction($event, item)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item.caption) +
                        "\n                "
                    )
                  ]
                )
              ])
            ]
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }